/** 导航滚动初始化事件 */
export const NAV_SCROLL_INIT_EVENT = 'NAV_SCROLL_INIT_EVENT';

/** 导航滚动帧事件 */
export const NAV_SCROLL_FRAME_EVENT = 'NAV_SCROLL_FRAME_EVENT';

/** 导航滚动帧事件 */
export const NAV_SCROLL_STOP_EVENT = 'NAV_SCROLL_STOP_EVENT';

/** 渲染图层事件 */
export const NAV_RENDER_STAGE_EVENT = 'NAV_RENDER_STAGE_EVENT';

export const NAV_SCROLL_EVENT = 'NAV_SCROLL_EVENT';

export const IS_DRAGGING_EVENT = 'IS_DRAGGING_EVENT';
